import * as React from 'react'
import { memo } from 'react'
const SvgArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path d="M10.791 6.313H0v-.627h10.791L5.552.447 6 0l6 6-6 6-.448-.448Z" />
  </svg>
)
const Memo = memo(SvgArrowRight)
export default Memo
